(function($) {

    $(".sidebar-news-items-slider").slick({
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        // fade: true,
        rows: 0,
    });

})( jQuery );